import React, { useState } from "react";
import {
  ThemeCheckBoxGroup,
  ThemeDragList,
  ThemeDragListContext,
  ThemeQSTCard,
  ThemeQstFormat,
  ThemeQstName,
  ThemeQstNumbers,
  ThemeQstTitle,
  ThemeQstType,
  ThemeRadioGroup,
} from "./QstStyle";
import {
  Checkbox,
  Col,
  Input,
  List,
  Radio,
  Row,
  Space,
  Typography,
} from "antd";
import {
  ThemeButton,
  ThemeCard,
  ThemeFilterBtn,
  ThemeInput,
} from "../../../Styles/Theme";

import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { HolderOutlined, MenuOutlined } from "@ant-design/icons";

// Welcome message component
const WelcomeMessage = () => {
  return (
    <>
      <ThemeQstTitle className="mb-3">
        Conversations are young men having that politicians seem unwilling to
        engage
      </ThemeQstTitle>
      <Space gap={10}>
        <ThemeFilterBtn
          shape="square"
          className="noBackground smallFont"
          icon={<img src="/images/massage-icon.svg" alt="Option" />}
        >
          Text only
        </ThemeFilterBtn>
        <ThemeFilterBtn
          shape="square"
          className="noBackground smallFont"
          icon={<img src="/images/massage-icon.svg" alt="Option" />}
        >
          Call AI JDV
        </ThemeFilterBtn>
      </Space>
    </>
  );
};

// Rating component
const Rating = () => {
  return (
    <>
      <ThemeQstNumbers className="mt-3">
        Least
        <div className="numberCard">0</div>
        <div className="numberCard">1</div>
        <div className="numberCard">2</div>
        <div className="numberCard">3</div>
        <div className="numberCard">4</div>
        <div className="numberCard">5</div>
        <div className="numberCard">6</div>
        <div className="numberCard active">7</div>
        <div className="numberCard">8</div>
        <div className="numberCard">9</div>
        <div className="numberCard">10</div>
        Most
      </ThemeQstNumbers>
    </>
  );
};

// Options with radio buttons component for single choice
const RadioButtons = () => {
  const [value, setValue] = useState(1);
  const onChange = (e) => {
    setValue(e.target.value);
  };
  return (
    <>
      <ThemeRadioGroup
        className="mt-3"
        onChange={onChange}
        value={value}
        options={[
          { value: 1, label: "Federal government" },
          { value: 2, label: "State and local governments" },
          { value: 3, label: "Corporations and businesses" },
          { value: 4, label: "Individuals (personal lifestyle choices)" },
          { value: 5, label: "All equally" },
          {
            value: 6,
            label: (
              <>
                Others
                {value === 6 && (
                  <ThemeInput
                    size="large"
                    variant="filled"
                    placeholder="Please enter your answer"
                    style={{ width: "75%", marginInlineStart: 12 }}
                  />
                )}
              </>
            ),
          },
        ]}
      />
    </>
  );
};

// Checkbox buttons component for multiple choice
const CheckBoxButtons = () => {
  const [value, setValue] = useState(1);
  const onChange = (e) => {
    setValue(e.target.value);
  };
  return (
    <>
      <ThemeCheckBoxGroup>
        <Row>
          <Col xs={24} className="mb-2">
            <Checkbox value="federal-government">Federal government</Checkbox>
          </Col>
          <Col xs={24} className="mb-2">
            <Checkbox value="state-and-local-governments">
              State and local governments
            </Checkbox>
          </Col>
          <Col xs={24} className="mb-2">
            <Checkbox value="corporations-and-businesses">
              Corporations and businesses
            </Checkbox>
          </Col>
          <Col xs={24} className="mb-2">
            <Checkbox value="individuals-personal-lifestyle-choices">
              Individuals (personal lifestyle choices)
            </Checkbox>
          </Col>
          <Col xs={24}>
            <Checkbox value="all-equally">All equally</Checkbox>
          </Col>
        </Row>
      </ThemeCheckBoxGroup>
    </>
  );
};

// Drag and drop list component
const SortableItem = ({ item }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    boxShadow: isDragging ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
  };

  return (
    <ThemeDragList
      ref={setNodeRef}
      style={style}
      {...attributes}
      isDragging={isDragging}
      transition={transition}
    >
      <Row className="items-center">
        <Col xs={20}>
          <div className="title">{item.title}</div>
        </Col>
        <Col xs={4} className="text-end">
          <div {...listeners} className="dragPointer">
            <HolderOutlined />
          </div>
        </Col>
      </Row>
    </ThemeDragList>
  );
};
const DragListElement = () => {
  const [items, setItems] = useState([
    { id: "1", title: "Task 1: Learn dnd-kit" },
    { id: "2", title: "Task 2: Build a reorder list" },
    { id: "3", title: "Task 3: Deploy the demo" },
    { id: "4", title: "Task 4: Enjoy the results" },
  ]);
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setItems((prevItems) => {
        const activeIndex = prevItems.findIndex(
          (item) => item.id === active.id
        );
        const overIndex = prevItems.findIndex((item) => item.id === over.id);

        // Helper function to reorder arrays
        const newItems = [...prevItems];
        const [removed] = newItems.splice(activeIndex, 1);
        newItems.splice(overIndex, 0, removed);

        return newItems;
      });
    }
  };
  return (
    <>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <ThemeDragListContext
          items={items}
          strategy={verticalListSortingStrategy}
        >
          <List
            dataSource={items}
            renderItem={(item) => <SortableItem key={item.id} item={item} />}
          />
        </ThemeDragListContext>
      </DndContext>
    </>
  );
};

// Checkbox buttons component for multiple choice
const QstType = () => {
  const [value, setValue] = useState(1);
  const onChange = (e) => {
    setValue(e.target.value);
  };
  return (
    <ThemeQstType className="mt-3">
      <div className="themeQstTypeGrid">
        <img src="/images/check-icon.svg" alt="Option" />
        Option
      </div>
      <div className="themeQstTypeGrid">
        <img src="/images/text-icon.svg" alt="Option" />
        Text
      </div>
      <div className="themeQstTypeGrid">
        <img src="/images/scale-icon.svg" alt="Option" />
        Scale
      </div>
      <div className="themeQstTypeGrid">
        <img src="/images/picture-icon.svg" alt="Option" />
        Picture
      </div>
      <div className="themeQstTypeGrid">
        <img src="/images/single-choice-icon.svg" alt="Option" />
        Single Choice
      </div>
      <div className="themeQstTypeGrid">
        <img src="/images/multi-select-icon.svg" alt="Option" />
        Multi Select
      </div>
      <div className="themeQstTypeGrid">
        <img src="/images/upload-icon.svg" alt="Option" />
        File
      </div>
      <div className="themeQstTypeGrid">
        <img src="/images/email-icon.svg" alt="Option" />
        Email
      </div>
      <div className="themeQstTypeGrid">
        <img src="/images/number-icon.svg" alt="Option" />
        Number
      </div>
      <div className="themeQstTypeGrid">
        <img src="/images/matrix-icon.svg" alt="Option" />
        Matrix
      </div>
      <div className="themeQstTypeGrid">
        <img src="/images/ranking-icon.svg" alt="Option" />
        Ranking
      </div>
      <div className="themeQstTypeGrid">
        <img src="/images/video-icon.svg" alt="Option" />
        Video
      </div>
    </ThemeQstType>
  );
};
// Export all components
export {
  WelcomeMessage,
  Rating,
  RadioButtons,
  CheckBoxButtons,
  DragListElement,
  QstType,
};
export default WelcomeMessage; // Keep default export for backward compatibility
